/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 退出登录,并清除redis中的token
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/oauth2/token-clear`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
